import { LayoutProps } from "./layoutTypes";

const CenteredLayout = ({ children }: LayoutProps) => {
  return <div>{children}</div>;
};

export default CenteredLayout;
